/* ELYXEN PREMIUM 2026 - interacciones */
(function(){
  'use strict';
  var d=document, root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s));}
  function money(c){return (c/100).toLocaleString('es-ES',{style:'currency',currency:'EUR'});}

  /* Reveal on scroll */
  function initReveal(c){
    var els=$$('[data-ex-reveal]:not(.is-in)',c);
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e)});
  }

  /* Generic cycler */
  function cycle(items,ms,cls){
    if(items.length<2||items[0].dataset.exCycling)return;
    items[0].dataset.exCycling='1';
    var i=0; items.forEach(function(e,k){e.classList.toggle(cls||'is-on',k===0)});
    setInterval(function(){
      var prev=items[i]; i=(i+1)%items.length;
      prev.classList.remove(cls||'is-on'); prev.classList.add('is-out');
      setTimeout(function(){prev.classList.remove('is-out')},900);
      items[i].classList.add(cls||'is-on');
    },ms);
  }
  function initCyclers(c){
    $$('[data-ex-rotator]',c).forEach(function(r){cycle($$('span',r),2600)});
    $$('[data-ex-slides]',c).forEach(function(r){cycle($$('img',r),5200)});
    $$('[data-ex-fslides]',c).forEach(function(r){cycle($$('.ex-float__slide',r),3800)});
  }

  /* Mouse parallax */
  function initParallax(c){
    if(reduce)return;
    $$('[data-ex-mouse]',c).forEach(function(w){
      w.addEventListener('mousemove',function(e){
        var r=w.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
        $$('[data-depth]',w).forEach(function(el){var dp=parseFloat(el.dataset.depth)||10;el.style.transform='translate('+(-x*dp)+'px,'+(-y*dp)+'px)';});
      });
      w.addEventListener('mouseleave',function(){$$('[data-depth]',w).forEach(function(el){el.style.transform=''})});
    });
    var pars=$$('[data-ex-par]',c); if(!pars.length)return;
    var tick=false;
    function run(){pars.forEach(function(el){var r=el.parentNode.getBoundingClientRect();var p=(r.top+r.height/2-innerHeight/2)/innerHeight;el.style.transform='translateY('+(p*(parseFloat(el.dataset.exPar)||-40))+'px)';});tick=false;}
    addEventListener('scroll',function(){if(!tick){requestAnimationFrame(run);tick=true;}},{passive:true}); run();
  }

  /* Count up */
  function initCount(c){
    var els=$$('[data-ex-count]',c); if(!els.length)return;
    var io=new IntersectionObserver(function(en){en.forEach(function(x){
      if(!x.isIntersecting)return; io.unobserve(x.target);
      var el=x.target,to=parseFloat(el.dataset.exCount),t0=null,dur=1600;
      if(reduce){el.textContent=to;return;}
      function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=Math.round(to*e);if(p<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);
    })},{threshold:.5});
    els.forEach(function(e){io.observe(e)});
  }

  /* Cutoff countdown: pedidos antes de las 14:00 (L-V) salen hoy */
  function initCutoff(c){
    var els=$$('[data-ex-cutoff]',c); if(!els.length)return;
    function madrid(){
      var parts={}; new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}).formatToParts(new Date()).forEach(function(p){parts[p.type]=p.value});
      return {wd:parts.weekday,h:+parts.hour,m:+parts.minute,s:+parts.second};
    }
    function upd(){
      var t=madrid(),cut=parseInt(els[0].dataset.exCutoff||'14',10),wk=['Mon','Tue','Wed','Thu','Fri'].indexOf(t.wd)>-1;
      var left=(cut*3600)-(t.h*3600+t.m*60+t.s),html;
      if(wk&&left>0){var hh=Math.floor(left/3600),mm=Math.floor(left%3600/60),ss=left%60;
        html='Pide en las próximas <b>'+hh+'h '+String(mm).padStart(2,'0')+'m '+String(ss).padStart(2,'0')+'s</b> y tu pedido sale hoy';}
      else{var next=(t.wd==='Fri'&&left<=0)||t.wd==='Sat'||t.wd==='Sun'?'el lunes':'mañana';html='Pide ahora y tu pedido sale <b>'+next+'</b> por la mañana';}
      els.forEach(function(e){var tx=e.querySelector('[data-ex-cutoff-text]');if(tx)tx.innerHTML=html;});
    }
    upd(); setInterval(upd,1000);
  }

  /* Auto-moving draggable track */
  function initTracks(c){
    $$('[data-ex-track]',c).forEach(function(tr){
      if(tr.dataset.exInit)return; tr.dataset.exInit='1';
      var sec=tr.closest('.ex')||d, speed=parseFloat(tr.dataset.exTrack)||.45, paused=false, drag=false, sx=0, sl=0, moved=0, acc=0;
      var bar=sec.querySelector('[data-ex-bar]');
      function half(){return tr.scrollWidth/2;}
      function loop(){
        if(!paused&&!drag&&!reduce){acc+=speed; if(acc>=1){var n=Math.floor(acc);tr.scrollLeft+=n;acc-=n;}}
        if(tr.scrollLeft>=half())tr.scrollLeft-=half();
        if(bar){bar.style.width=(tr.scrollLeft%half())/half()*100+'%';}
        requestAnimationFrame(loop);
      }
      tr.addEventListener('mouseenter',function(){paused=true});
      tr.addEventListener('mouseleave',function(){paused=false;drag=false;tr.classList.remove('is-drag')});
      tr.addEventListener('touchstart',function(){paused=true},{passive:true});
      tr.addEventListener('touchend',function(){setTimeout(function(){paused=false},2500)});
      tr.addEventListener('focusin',function(){paused=true});
      tr.addEventListener('focusout',function(){paused=false});
      tr.addEventListener('mousedown',function(e){drag=true;moved=0;sx=e.pageX;sl=tr.scrollLeft;});
      addEventListener('mouseup',function(){if(drag){drag=false;tr.classList.remove('is-drag');}});
      tr.addEventListener('mousemove',function(e){if(!drag)return;var dx=e.pageX-sx;moved=Math.abs(dx);if(moved>5)tr.classList.add('is-drag');tr.scrollLeft=sl-dx;if(tr.scrollLeft<0)tr.scrollLeft+=half();});
      tr.addEventListener('click',function(e){if(moved>5){e.preventDefault();e.stopPropagation();moved=0;}},true);
      function jump(dir){var card=tr.firstElementChild;var w=card?card.getBoundingClientRect().width+22:300;
        if(dir<0&&tr.scrollLeft<w)tr.scrollLeft+=half();
        tr.style.scrollBehavior='smooth';tr.scrollLeft+=dir*w;setTimeout(function(){tr.style.scrollBehavior='auto'},600);}
      $$('[data-ex-prev]',sec).forEach(function(b){b.addEventListener('click',function(){jump(-1)})});
      $$('[data-ex-next]',sec).forEach(function(b){b.addEventListener('click',function(){jump(1)})});
      requestAnimationFrame(loop);
    });
  }

  /* Tabs & filters */
  function initTabs(c){
    $$('[data-ex-tabs]',c).forEach(function(w){
      var btns=$$('[data-tab]',w),pans=$$('[data-panel]',w);
      btns.forEach(function(b){b.addEventListener('click',function(){
        btns.forEach(function(x){x.classList.toggle('is-on',x===b);x.setAttribute('aria-selected',x===b)});
        pans.forEach(function(p){p.classList.toggle('is-on',p.dataset.panel===b.dataset.tab)});
      })});
    });
    $$('[data-ex-filter]',c).forEach(function(w){
      var sec=w.closest('.ex'),btns=$$('[data-filter]',w),cards=$$('[data-group]',sec);
      btns.forEach(function(b){b.addEventListener('click',function(){
        var f=b.dataset.filter; btns.forEach(function(x){x.classList.toggle('is-on',x===b)});
        cards.forEach(function(cd,i){var show=f==='all'||(' '+cd.dataset.group+' ').indexOf(' '+f+' ')>-1;
          if(show){cd.classList.remove('is-hidden');cd.animate&&cd.animate([{opacity:0,transform:'translateY(20px)'},{opacity:1,transform:'none'}],{duration:500,delay:i*40,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});}
          else cd.classList.add('is-hidden');});
      })});
    });
  }

  /* 3D tilt */
  function initTilt(c){
    if(reduce||!matchMedia('(hover:hover)').matches)return;
    $$('[data-ex-tilt]',c).forEach(function(el){
      el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;el.style.transform='perspective(900px) rotateY('+(x*8)+'deg) rotateX('+(-y*8)+'deg)';});
      el.addEventListener('mouseleave',function(){el.style.transform=''});
    });
  }

  /* Toast */
  var toast;
  function showToast(msg){
    if(!toast){toast=d.createElement('div');toast.className='ex-toast';toast.setAttribute('role','status');d.body.appendChild(toast);}
    toast.innerHTML='<span>'+msg+'</span><a href="'+root+'cart">Ver carrito</a>';
    toast.classList.add('is-on'); clearTimeout(toast._t); toast._t=setTimeout(function(){toast.classList.remove('is-on')},4200);
  }

  /* Add to cart (single / many) */
  function addItems(items,btn){
    btn.classList.add('is-loading');
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;})})
    .then(function(){return fetch(root+'cart.js').then(function(r){return r.json()})})
    .then(function(cart){
      btn.classList.remove('is-loading'); btn.classList.add('is-done');
      var old=btn.innerHTML; if(!btn.classList.contains('ex-add'))btn.innerHTML='Añadido ✓';
      setTimeout(function(){btn.classList.remove('is-done');btn.innerHTML=old;},2200);
      try{d.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ex-quick-add',data:{itemCount:cart.item_count,source:'ex-quick-add'}}}));}catch(e){}
      var left=(parseInt(btn.dataset.exFree||'5000',10))-cart.total_price;
      showToast(items.length>1?'Rutina añadida al carrito':'Añadido al carrito'+(left>0?' · Te faltan '+money(left)+' para envío gratis':' · ¡Envío gratis conseguido!'));
    })
    .catch(function(err){btn.classList.remove('is-loading');showToast((err&&err.description)||'No se pudo añadir. Inténtalo de nuevo.');});
  }
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-ex-add]');
    if(b){e.preventDefault();addItems(b.dataset.exAdd.split(',').filter(Boolean).map(function(id){return{id:parseInt(id,10),quantity:1}}),b);return;}
    var h=e.target.closest('.ex-hot__btn');
    if(h){var hot=h.parentNode,on=!hot.classList.contains('is-on');$$('.ex-hot',hot.parentNode).forEach(function(x){x.classList.remove('is-on')});hot.classList.toggle('is-on',on);
      var sec=hot.closest('.ex');$$('[data-hot-card]',sec).forEach(function(cd){cd.classList.toggle('is-on',on&&cd.dataset.hotCard===hot.dataset.hot)});return;}
    var cd=e.target.closest('[data-hot-card]');
    if(cd){var s=cd.closest('.ex');$$('[data-hot-card]',s).forEach(function(x){x.classList.toggle('is-on',x===cd)});$$('.ex-hot',s).forEach(function(x){x.classList.toggle('is-on',x.dataset.hot===cd.dataset.hotCard)});return;}
    var cp=e.target.closest('[data-ex-copy]');
    if(cp){var code=cp.dataset.exCopy;(navigator.clipboard?navigator.clipboard.writeText(code):Promise.reject()).then(function(){cp.textContent='¡Copiado!'}).catch(function(){cp.textContent=code});}
  });

  /* Popup */
  function initPopup(c){
    $$('[data-ex-pop]',c).forEach(function(p){
      if(p.dataset.exInit)return; p.dataset.exInit='1';
      var key='ex-pop-seen',days=parseInt(p.dataset.days||'7',10),seen=null;
      try{seen=localStorage.getItem(key);}catch(e){}
      function open(){p.classList.add('is-on');p.setAttribute('aria-hidden','false');}
      function close(){p.classList.remove('is-on');p.setAttribute('aria-hidden','true');try{localStorage.setItem(key,Date.now());}catch(e){}}
      $$('[data-ex-close]',p).forEach(function(b){b.addEventListener('click',close)});
      d.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
      if(p.dataset.posted==='true'){open();return;}
      if(d.documentElement.classList.contains('shopify-design-mode'))return;
      if(seen&&Date.now()-parseInt(seen,10)<days*864e5)return;
      var fired=false;function fire(){if(fired)return;fired=true;open();}
      setTimeout(fire,(parseInt(p.dataset.delay||'8',10))*1000);
      d.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<5)fire();});
    });
  }

  function init(c){initReveal(c);initCyclers(c);initParallax(c);initCount(c);initCutoff(c);initTracks(c);initTabs(c);initTilt(c);initPopup(c);}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init(d)});else init(d);
  d.addEventListener('shopify:section:load',function(e){init(e.target)});
})();